$(document).ready(function () {
  
    if($('body.search').length > 0){
    
    var searchInterval = setInterval(function(){
      
      if($('.boost-pfs-filter-tree-content').length > 0){
        
        clearInterval(searchInterval);
        if($('.result-empty-search').length == 0){
          $('body').addClass('have-result');
          
        }else{
          $('body').addClass('no-result');
        }
      }
    }, 200);
  }
  
    if($('body.collection').length > 0){
    
    var searchInterval = setInterval(function(){
    
      if($('.boost-pfs-filter-tree-content').length > 0){
    
        clearInterval(searchInterval);
        if($('.boost-pfs-filter-message em').text() == "Sorry, no products matched your selection"){
    
          $('body').addClass('empty-collection');
          
        }
      }
    }, 200);
  }
  
  if($('body.collection .product-grid').length > 0){
    
    $('.more').click(function(){
    	$('.boost-pfs-filter-load-more-button').click();
    })
    
    
    if(parseInt($('#current-count').text()) >= parseInt($('#full-count').text())){
      $('#current-count').text($('#full-count').text());
      if($('.boost-pfs-filter-load-more').is(":visible")){
        $('.more').show();
      }else{
      	$('.more').hide();
      }

    }
    $('.boost-pfs-filter-tree').bind('DOMSubtreeModified', function(){
    	 $("html, body").animate({scrollTop: 0}, 0);
    })

    $('#main-collection-product-grid').bind('DOMSubtreeModified', function(){
       
      setTimeout(function(){
      	    $('#current-count').text($('.grid__item').length);
            var productCountFilter = $('.product-count__text.boost-pfs-filter-total-product').text().split(' ')[0];
            
         	$('.products-count').text(productCountFilter+" Items").css('opacity','1');
            $('#full-count').text(productCountFilter);
           if(parseInt($('#current-count').text()) >= parseInt($('#full-count').text())){
             $('#current-count').text($('#full-count').text());
           }
            if($('.boost-pfs-filter-load-more').is(":visible")){
              $('.more').show();
            }else{
              $('.more').hide();
            }
        
            if($('.card__badge .badge:not(.converted)').length > 0){
              $('.card__badge .badge:not(.converted)').each(function(){
                $(this).addClass('converted');
                parseInt($('.price-old').text().replace(/[^0-9.]/g, "")); 
                var regularPrice = parseInt($(this).parents('.grid__item').find('.price__sale .price-item--regular').text().replace(/[^0-9.]/g, ""));
                var salePrice = parseInt($(this).parents('.grid__item').find('.price-item--sale').text().replace(/[^0-9.]/g, ""));
                var savePrice = regularPrice - salePrice;
                $(this).text('Save $'+savePrice);
              })
            }
        
            if($('.card-footer:not(.converted)').length > 0){
              $('.card-footer:not(.converted)').each(function(){
                $(this).addClass('converted');
                var currentPrice = parseInt($(this).parents('.grid__item').find('.price-item--sale').text().replace(/[^0-9.]/g, "")).toFixed(2);
                $(this).find('span').text('$'+(currentPrice*0.98).toFixed(2));
              })
            }

            if($(window).width() >= 768){
              stickyWidth = $('.boost-pfs-filter-left-col').innerWidth();
              headerHeight = $('header').innerHeight();
              stickyTop = $('.boost-pfs-container-default-box').offset().top;
              parentHeight = $('.boost-pfs-container-default-box').innerHeight();
              stickyHeight = $('.boost-pfs-filter-left-col').innerHeight();
                var windowTop = $(window).scrollTop();
                if (stickyTop - headerHeight - 20 <= windowTop) {
                  if(stickyTop  - headerHeight - 20 - stickyHeight + parentHeight >= windowTop){
                    $('.boost-pfs-filter-left-col').css({
                      'position': 'fixed',
                      'max-width': stickyWidth,
                      'bottom': 'auto',
                      'top': headerHeight + 20
                    })
                  }else{
                    $('.boost-pfs-filter-left-col').css({
                      'position': 'absolute',
                      'max-width': stickyWidth,
                      'bottom': '0',
                      'top': 'auto'
                    })
                  }
                } else {
                  $('.boost-pfs-filter-left-col').css('position', 'static').css('max-width', 'none');
                }
              }
      }, 100)


    })
       var productCountIntervalFilter = setInterval(function(){
        if($.isNumeric($('.product-count__text.boost-pfs-filter-total-product').text().split(' ')[0])){
		  if($('.boost-pfs-filter-load-more').is(":visible")){
            $('.more').show();
          }else{
            $('.more').hide();
          }
          var productCountFilter = $('.product-count__text.boost-pfs-filter-total-product').text().split(' ')[0];
          $('.products-count').text(productCountFilter+" Items").css('opacity','1');
          $('#full-count').text(productCountFilter);
          
          $('#current-count').text($('.grid__item').length);
          if(parseInt($('#current-count').text()) >= parseInt($('#full-count').text())){
            $('#current-count').text($('#full-count').text());
          }
          
          clearInterval(productCountIntervalFilter);
        }
      }, 200);
      setTimeout(function(){
          clearInterval(productCountIntervalFilter);
      }, 5000);
  }
  
  if($('body.search .boost-pfs-search-total-result').length > 0){
    
    $('.more').click(function(){
    	$('.boost-pfs-filter-load-more-button').click();
    })
    
    

    $('.boost-pfs-filter-products').bind('DOMSubtreeModified', function(){
      
      setTimeout(function(){
        	
      	    $('#current-count').text($('.grid__item').length);
            var productCountFilterSearch = $('.boost-pfs-search-total-result strong').text();
            
         	$('.products-count').text(productCountFilterSearch+" Items").css('opacity','1');
            $('#full-count').text(productCountFilterSearch);
           if(parseInt($('#current-count').text()) >= parseInt($('#full-count').text())){
             $('#current-count').text($('#full-count').text());
           }
            if($('.boost-pfs-filter-load-more').is(":visible")){
              $('.more').show();
            }else{
              $('.more').hide();
            }
        
          	if($('.card__badge .badge:not(.converted)').length > 0){
              $('.card__badge .badge:not(.converted)').each(function(){
                $(this).addClass('converted');
                parseInt($('.price-old').text().replace(/[^0-9.]/g, "")); 
                var regularPrice = parseInt($(this).parents('.grid__item').find('.price__sale .price-item--regular').text().replace(/[^0-9.]/g, ""));
                var salePrice = parseInt($(this).parents('.grid__item').find('.price-item--sale').text().replace(/[^0-9.]/g, ""));
                var savePrice = regularPrice - salePrice;
                $(this).text('Sale $'+savePrice);
              })
            }
        
            if($('.card-footer:not(.converted)').length > 0){
              $('.card-footer:not(.converted)').each(function(){
                $(this).addClass('converted');
                var currentPrice = parseInt($(this).parents('.grid__item').find('.price-item--sale').text().replace(/[^0-9.]/g, ""));
                $(this).find('span').text('$'+(currentPrice*0.98).toFixed(2));
              })
            }
        
        	if($(window).width() >= 768){
              stickyWidth = $('.boost-pfs-filter-tree').innerWidth();
              headerHeight = $('header').innerHeight();
              stickyTop = $('.boost-pfs-filter-wrapper').offset().top;
              parentHeight = $('.boost-pfs-filter-wrapper').innerHeight();
              stickyHeight = $('.boost-pfs-filter-tree').innerHeight();
                var windowTop = $(window).scrollTop();
                if (stickyTop - headerHeight - 20 <= windowTop) {
                  if(stickyTop  - headerHeight - 20 - stickyHeight + parentHeight >= windowTop){
                    $('.boost-pfs-filter-tree').css({
                      'position': 'fixed',
                      'max-width': stickyWidth,
                      'bottom': 'auto',
                      'top': headerHeight + 20
                    })
                  }else{
                    $('.boost-pfs-filter-tree').css({
                      'position': 'absolute',
                      'max-width': stickyWidth,
                      'bottom': '0',
                      'top': 'auto'
                    })
                  }
                } else {
                  $('.boost-pfs-filter-tree').css('position', 'static').css('max-width', 'none');
                }
              }

      }, 200)

  
    });
    
    var productCountIntervalFilterSearch = setInterval(function(){
      	
        if($('.boost-pfs-search-total-result strong').text() !== "0"){
          
          if($('.boost-pfs-filter-load-more').is(":visible")){
            $('.more').show();
          }else{
            $('.more').hide();
          }
          
          var productCountFilterSearch = $('.boost-pfs-search-total-result strong').text();
          $('.collection-option .products-count').text(productCountFilterSearch+" Items").css('opacity','1');
          
          $('#full-count').text(productCountFilterSearch);
          $('#current-count').text($('.grid__item').length);
          
          if(parseInt($('#current-count').text()) >= parseInt($('#full-count').text())){
            $('#current-count').text($('#full-count').text());
          }
          
          clearInterval(productCountIntervalFilterSearch);
        }
      }, 200);
      setTimeout(function(){
        clearInterval(productCountIntervalFilterSearch);
      }, 5000);
      
  }
  
  
  
  if($('.boost-pfs-filter-left-col').length > 0){
    var stickyWidth = $('.boost-pfs-filter-left-col').innerWidth();
    var stickyTop = $('.boost-pfs-container-default-box').offset().top;
    var headerHeight = $('header').innerHeight();
    var parentHeight = $('.boost-pfs-container-default-box').innerHeight();
    var stickyHeight = $('.boost-pfs-filter-left-col').innerHeight();
    $(window).scroll(function(){
      if($(window).width() >= 768){
        stickyWidth = $('.boost-pfs-filter-left-col').innerWidth();
        headerHeight = $('header').innerHeight();
        stickyTop = $('.boost-pfs-container-default-box').offset().top;
        parentHeight = $('.boost-pfs-container-default-box').innerHeight();
        stickyHeight = $('.boost-pfs-filter-left-col').innerHeight();
          var windowTop = $(window).scrollTop();
          if (stickyTop - headerHeight - 20 <= windowTop) {
            if(stickyTop  - headerHeight - 20 - stickyHeight + parentHeight >= windowTop){
              $('.boost-pfs-filter-left-col').css({
                'position': 'fixed',
                'max-width': stickyWidth,
                'bottom': 'auto',
                'top': headerHeight + 20
              })
            }else{
              $('.boost-pfs-filter-left-col').css({
                'position': 'absolute',
                'max-width': stickyWidth,
                'bottom': '0',
                'top': 'auto'
              })
            }
          } else {
            $('.boost-pfs-filter-left-col').css('position', 'static').css('max-width', 'none');
          }
        }
    })
  };
  
  if($('.search .boost-pfs-filter-tree').length > 0){
      
      var stickyWidth = $('.boost-pfs-filter-tree').innerWidth();
      var stickyTop = $('.boost-pfs-filter-wrapper').offset().top;
      var headerHeight = $('header').innerHeight();
      var parentHeight = $('.boost-pfs-filter-wrapper').innerHeight();
      var stickyHeight = $('.boost-pfs-filter-tree').innerHeight();
      $(window).scroll(function(){
        if($(window).width() >= 768){
          stickyWidth = $('.boost-pfs-filter-tree').innerWidth();
          headerHeight = $('header').innerHeight();
          stickyTop = $('.boost-pfs-filter-wrapper').offset().top;
          parentHeight = $('.boost-pfs-filter-wrapper').innerHeight();
          stickyHeight = $('.boost-pfs-filter-tree').innerHeight();
            var windowTop = $(window).scrollTop();
            if (stickyTop - headerHeight - 20 <= windowTop) {
              if(stickyTop  - headerHeight - 20 - stickyHeight + parentHeight >= windowTop){
                $('.boost-pfs-filter-tree').css({
                  'position': 'fixed',
                  'max-width': stickyWidth,
                  'bottom': 'auto',
                  'top': headerHeight + 20
                })
              }else{
                $('.boost-pfs-filter-tree').css({
                  'position': 'absolute',
                  'max-width': stickyWidth,
                  'bottom': '0',
                  'top': 'auto'
                })
              }
            } else {
              $('.boost-pfs-filter-tree').css('position', 'static').css('max-width', 'none');
            }
          }
      });
    }
  
  
  $('.accordion-header').click(function(){
    $('.accordion-header').not(this).parent().removeClass('open');
    $(this).parent().toggleClass('open');
  })

  

});